import { path } from 'ramda';
import actionTypes, { RESET_COMPRESSED_IMAGES, RESET_STORE_IMAGES } from './actionTypes';
import api from '../operations/api/api';
import { ApiAddresses, DefaultParams } from '../common/apiAddresses';
import { makeQueryParams } from "../operations/operations";
import moment from 'moment';
import { compressImages } from "../operations/utils/imageCompression";

export const setOrderDetailImages = function(id, images, imageType) {
  return dispatch => {
    if (imageType === 'reason') {
      dispatch({ type: actionTypes.ORDER_RESAON_DETAIL_IMAGES_DONE, images, id });
    } else if (imageType === 'invoice') {
      dispatch({ type: actionTypes.INVOICE_IMAGES_DONE, images, id });
    } else if (imageType === 'store_image') {
      dispatch({ type: actionTypes.STORE_IMAGES_DONE, images, id });
    } else {
      dispatch({ type: actionTypes.ORDER_DETAIL_IMAGES_DONE, images, id });
    }
  };
};

export const resetOrderDetailImagesStatus = function() {
  return dispatch => {
    dispatch({ type: actionTypes.ORDER_RESAON_DETAIL_IMAGES_BEGIN });
    dispatch({ type: actionTypes.INVOICE_IMAGES_BEGIN });
    dispatch({ type: actionTypes.ORDER_DETAIL_IMAGES_BEGIN });
  };
};

export const resetOrderDetailImages = function() {
  return dispatch => {

    dispatch({ type: actionTypes.RESET_ORDER_DETAIL_IMAGES_DONE });
  };
};

export const removeImageFromOrder = function(id) {
  return dispatch => {
    dispatch({ type: actionTypes.REMOVE_DETAIL_IMAGES_ORDER_DONE, id });
  };
};

export const removeImage = function(e, index, images, id) {
  return dispatch => {
    let imagesModified = images.filter((ele, currIndex) => {
      if (currIndex != index) {
        return ele
      }
    })
    dispatch({ type: actionTypes.REMOVE_DETAIL_IMAGES_DONE, images: imagesModified, id });
  };
};

export const logoutAction = function(payload) {
  return dispatch => {
    window.localStorage.removeItem('token');
    dispatch({ type: actionTypes.LOGOUT_DONE });
  };
};

export const getOrderDetails = function(id) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_ORDER_DETAILS_BEGIN });

    api()
      .get(`${ApiAddresses.getOrderDetails}${id}`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_ORDER_DETAILS_DONE, orderDetails: data.response });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ORDER_DETAILS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const getOrderPhones = function(id) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_ORDER_PHONES_BEGIN });

    api()
      .get(`${ApiAddresses.getOrderPhones}${id}/phones`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_ORDER_PHONES_DONE, orderPhones: data.response });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ORDER_PHONES_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const getOrderProducts = function(id) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_ORDER_PRODUCTS_BEGIN });

    api()
      .get(`${ApiAddresses.getOrderProducts}${id}/products`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_ORDER_PRODUCTS_DONE, orderProducts: data.response });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ORDER_PRODUCTS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const getOrders = function(params) {
  return dispatch => {
    let currentDateTime = moment().format('DD-MM-YYYY');
    const queryParams = DefaultParams.getOrders;
    queryParams.targetDeliveryDate = currentDateTime;
    let queryString = makeQueryParams(queryParams, params);
    dispatch({ type: actionTypes.GET_ORDERS_BEGIN });

    api()
      .get(`${ApiAddresses.getOrders}${queryString}`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_ORDERS_DONE, orders: data.response.orders });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ORDERS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })

  };
};

export const getAllIssueReasons = function(type) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_ALL_ISSUE_REASONS_BEGIN });

    api()
      .get(`${ApiAddresses.getAllIssueReasons}${type}`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_ALL_ISSUE_REASONS_DONE, reasons: data.response });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ALL_ISSUE_REASONS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })

  };
};

export const getAllDeliveryIssueReasons = function(type) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_DELIEVRY_ISSUE_REASONS_BEGIN });
    api()
      .get(`${ApiAddresses.getAllIssueReasons}${type}`)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_DELIEVRY_ISSUE_REASONS_DONE, deliveryReasons: data.response });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_DELIEVRY_ISSUE_REASONS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const addRemarks = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.ADD_REMARKS_BEGIN });

    api()
      .post(`${ApiAddresses.addRemarks}${payload.orderId}/remarks/order_remark/${payload.orderId}`, { remark: payload.remark })
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.ADD_REMARKS_DONE, remark: payload });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.ADD_REMARKS_FAIL,
          errors: path(['response', 'data'], err),
        });
      })

  };
};

export const saveProductIssues = function(payload, productId, orderId, issueId) {
  return dispatch => {
    dispatch({ type: actionTypes.SAVE_PRODUCT_ISSUES_BEGIN });
    let apiMock;
    if (issueId) {
      apiMock = (urlConfig, payload) => {
        return api()
          .put(urlConfig + '/' + issueId, payload)
      }
    } else {
      apiMock = (urlConfig, payload) => {
        return api()
          .post(urlConfig, payload)
      }
    }
    apiMock(`${ApiAddresses.saveProductIssues}${orderId}/products/${productId}/issues`, payload)
      .then(({ data, headers }) => {
        if (issueId) {
          dispatch({ type: actionTypes.SAVE_PRODUCT_ISSUES_DONE, updatedProductIssue: issueId, productId });
        } else {
          dispatch({ type: actionTypes.SAVE_PRODUCT_ISSUES_DONE, updatedProductIssue: data.response, productId });
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.SAVE_PRODUCT_ISSUES_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const deleteProductIssues = function(productId, orderId, issueId) {
  return dispatch => {
    dispatch({ type: actionTypes.DELETE_PRODUCT_ISSUES_BEGIN });
    const apiMock = (urlConfig, payload) => {
      return api()
        .delete(urlConfig + '/' + issueId)
    }
    apiMock(`${ApiAddresses.saveProductIssues}${orderId}/products/${productId}/issues`)
      .then(({ data, headers }) => {

        dispatch({ type: actionTypes.DELETE_PRODUCT_ISSUES_DONE, updatedProductIssue: null, productId });

      })
      .catch(err => {
        dispatch({
          type: actionTypes.DELETE_PRODUCT_ISSUES_FAIL,
          errors: path(['response', 'data'], err),
        });
      })

  };
};

export const updateOrder = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.UPDATE_ORDER_BEGIN });

    api()
      .put(`${ApiAddresses.updateOrder}${payload.orderId}`, payload.data)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.UPDATE_ORDER_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.UPDATE_ORDER_FAIL,
          errors: path(['response', 'data'], err),
        });
      })

  };
};

// export const setOrderStatusAction = function(payload) {
//   return dispatch => {
//     dispatch({ type: actionTypes.ORDER_STATUS_ACTION_BEGIN });

//     api()
//       .post(`${ApiAddresses.setOrdersStatusAction}`, payload)
//       .then(({ data, headers }) => {
//         dispatch({ type: actionTypes.ORDER_STATUS_ACTION_DONE });
//       })
//       .catch(err => {
//         dispatch({
//           type: actionTypes.ORDER_STATUS_ACTION_FAIL,
//           errors: path(['response', 'data'], err),
//         });
//       })
//   };
// };

export const resetGetOrders = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.RESET_GET_ORDERS_DONE });
  };
};

export const addWave = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.ADD_WAVE_BEGIN });

    api()
      .post(`${ApiAddresses.addWave}`, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.ADD_WAVE_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.ADD_WAVE_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const reUploadWave = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.REUPLOAD_WAVE_BEGIN });

    api()
      .put(`${ApiAddresses.addWave}`, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.REUPLOAD_WAVE_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.REUPLOAD_WAVE_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const uploadImages = function(payload, imageType) {
  return dispatch => {
    dispatch({ type: actionTypes.UPLOAD_IMAGES_BEGIN });
    api()
      .post(`${ApiAddresses.addImages}`, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.UPLOAD_IMAGES_DONE });
        dispatch({ type: RESET_COMPRESSED_IMAGES });
       if(imageType) {
         dispatch({ 
          type: RESET_STORE_IMAGES,
          imageType: imageType})
       }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.UPLOAD_IMAGES_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const verifyDeliveryOtp = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.VERIFY_DELIVERY_OTP_BEGIN });
    api()
      .post(ApiAddresses.verifyDeliveryOtp, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.VERIFY_DELIVERY_OTP_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.VERIFY_DELIVERY_OTP_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const updateDaCollectedAmount = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.UPDATE_DA_COLLECTED_AMOUNT_BEGIN });
    api()
      .put(ApiAddresses.updateDaCollectedAmount, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.UPDATE_DA_COLLECTED_AMOUNT_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.UPDATE_DA_COLLECTED_AMOUNT_FAIL,
          errors: path(['response','data', 'error', 'message'], err),
        });
      })
  };
};


export const resendDeliveryOtp = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.RESEND_DELIVERY_OTP_BEGIN });
    payload.countryCode = '91';
    api()
      .post(ApiAddresses.sendDeliveryOtp, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.RESEND_DELIVERY_OTP_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.RESEND_DELIVERY_OTP_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const sendDeliveryOtp = function(payload) {
  return dispatch => {
    dispatch({ type: actionTypes.SEND_DELIVERY_OTP_BEGIN });
    payload.countryCode = '91';
    api()
      .post(ApiAddresses.sendDeliveryOtp, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.SEND_DELIVERY_OTP_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.SEND_DELIVERY_OTP_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const cancelOrderDelivery = function(orderId, payload) {
  return dispatch => {
    dispatch({ type: actionTypes.CANCEL_DELIVERY_ISSUE_BEGIN });
    api()
      .post(`${ApiAddresses.deliveryIssue}${orderId}/deliveryIssue`, payload)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.CANCEL_DELIVERY_ISSUE_DONE });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.CANCEL_DELIVERY_ISSUE_FAIL,
          errors: path(['response', 'data'], err),
        });
      })
  };
};

export const resetCancelDeliverySatuses = function() {
  return dispatch => {
    dispatch({ type: actionTypes.CANCEL_DELIVERY_ISSUE_BEGIN })
  }
}

// Send add event request with retry. Wait for 1 second before each retry.
// This will send the request total 3 times.
const sendAddEventRequest = function(payload, retryCount=0) {
  api()
    .post(`${ApiAddresses.events}`, payload)
    .then(({ data, headers }) => {})
    .catch(err => {
      if (!err.response && retryCount < 2) {
        setTimeout(function(){
          retryCount++;
          sendAddEventRequest(payload, retryCount);
        }, 1000);
      }
    })
}

export const sendEvent = function(payload) {
  return dispatch => {
    payload.userType = 'da';
    payload.entityType = 'order';
    sendAddEventRequest(payload)
  }
}
